"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blake256 = exports.keccak160 = exports.pubkeyFromPrivateKey = exports.addressFromPrivateKey = exports.getSecp256k1PubkeyHash = exports.getPublicKey = exports.keyFromPrivate = exports.SigAlg = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const elliptic_1 = require("elliptic");
const js_sha3_1 = require("js-sha3");
const constants_1 = require("../constants");
const hex_1 = require("./hex");
var SigAlg;
(function (SigAlg) {
    SigAlg[SigAlg["Secp256r1"] = 0] = "Secp256r1";
    SigAlg[SigAlg["Secp256k1"] = 1] = "Secp256k1";
    SigAlg[SigAlg["RSA2048"] = 2] = "RSA2048";
})(SigAlg = exports.SigAlg || (exports.SigAlg = {}));
const keyFromPrivate = (privateKey, sigAlg = SigAlg.Secp256r1) => {
    if (sigAlg == SigAlg.RSA2048) {
        throw new Error('The SigAlg parameter cannot be RSA2048');
    }
    const privkey = typeof privateKey == 'string' ? (0, hex_1.remove0x)(privateKey) : privateKey;
    if (sigAlg == SigAlg.Secp256k1) {
        const ec = new elliptic_1.ec('secp256k1');
        return ec.keyFromPrivate(privkey);
    }
    const ec = new elliptic_1.ec('p256');
    return ec.keyFromPrivate(privkey);
};
exports.keyFromPrivate = keyFromPrivate;
// uncompressed pubkey without 0x
const getPublicKey = (key) => key.getPublic(false, 'hex').substring(2);
exports.getPublicKey = getPublicKey;
const getSecp256k1PubkeyHash = (key) => (0, exports.keccak160)(`0x${(0, exports.getPublicKey)(key)}`);
exports.getSecp256k1PubkeyHash = getSecp256k1PubkeyHash;
const addressFromPrivateKey = (privateKey, sigAlg = SigAlg.Secp256r1, isMainnet = false) => {
    if (sigAlg == SigAlg.RSA2048) {
        throw new Error('The SigAlg parameter cannot be RSA2048');
    }
    const pubkey = (0, hex_1.append0x)((0, exports.getPublicKey)((0, exports.keyFromPrivate)(privateKey, sigAlg)));
    const lock = Object.assign(Object.assign({}, (0, constants_1.getJoyIDLockScript)(isMainnet)), { args: sigAlg == SigAlg.Secp256r1 ? `0x0001${(0, ckb_sdk_utils_1.blake160)((0, ckb_sdk_utils_1.hexToBytes)(pubkey), 'hex')}` : `0x0002${(0, exports.keccak160)(pubkey)}` });
    return (0, ckb_sdk_utils_1.scriptToAddress)(lock, isMainnet);
};
exports.addressFromPrivateKey = addressFromPrivateKey;
const pubkeyFromPrivateKey = (privateKey, sigAlg = SigAlg.Secp256r1) => {
    return (0, hex_1.append0x)((0, exports.getPublicKey)((0, exports.keyFromPrivate)(privateKey, sigAlg)));
};
exports.pubkeyFromPrivateKey = pubkeyFromPrivateKey;
const keccak160 = (message) => {
    const msg = (0, ckb_sdk_utils_1.hexToBytes)(message);
    return (0, js_sha3_1.keccak_256)(msg).substring(24);
};
exports.keccak160 = keccak160;
const blake256 = (message) => {
    const hasher = (0, ckb_sdk_utils_1.blake2b)(32, null, null, ckb_sdk_utils_1.PERSONAL);
    hasher.update((0, ckb_sdk_utils_1.hexToBytes)(message));
    return `${hasher.digest('hex')}`;
};
exports.blake256 = blake256;
